import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import ReportContext from "../../../context/report/context";
import { IReport } from "../../../models/report/response";
import moment from "moment";
import Tag from "../../general/antd/tag";
import { getReportType, getReportTypeColor } from "../../../models/report/enum";
import Image from "../../general/antd/image";
import srcImage from "../../../assets/images/exel.png";
import { Popover, Row, Col } from "antd";
import styles from "./styles.module.scss";

interface IProps {}

const ReportList: React.FC<IProps> = (props) => {
  const { t } = useTranslation();

  const { list, actions, loading, query } = useContext(ReportContext);

  const formatDate = (value?: string | null) => {
    return value ? moment(value).format("YYYY-MM-DD") : "--";
  };

  const columns: ColumnProps<IReport>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      width: 100,
      align: "center",
    },
    {
      title: t("type"),
      dataIndex: "type",
      key: "type",
      align: "center",
      width: 100,
      render: (type) => {
        return (
          <Tag
            title={t(getReportType(type))}
            color={getReportTypeColor(type)}
          />
        );
      },
    },
    {
      title: t("start_date"),
      dataIndex: "startDate",
      key: "startDate",
      align: "center",
      width: 100,
      render: (startDate) => {
        return <>{formatDate(startDate)}</>;
      },
    },
    {
      title: t("end_date"),
      dataIndex: "endDate",
      key: "endDate",
      align: "center",
      width: 100,
      render: (endDate) => {
        return <>{formatDate(endDate)}</>;
      },
    },
    {
      title: t("report"),
      dataIndex: "report",
      key: "report",
      align: "center",
      width: 100,
      render: (report, record) => {
        const rawFileUrl = report?.url ?? record?.url ?? null;
        const fileUrl = rawFileUrl?.replace("http://", "https://") ?? null;

        if (!fileUrl) {
          return <>--</>;
        }

        return (
          <Popover content={<div>{t("click_here_to_download_file")}</div>}>
            <a href={fileUrl} download style={{ width: "50px" }}>
              <Row justify="center">
                <Col span={5}>
                  <div className={styles.fileCardContainer}>
                    <Image src={srcImage} className={styles?.imgFile} />
                  </div>
                </Col>
              </Row>
            </a>
          </Popover>
        );
      },
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default ReportList;
